import { render, staticRenderFns } from "./confirmFreight.vue?vue&type=template&id=8287766e&scoped=true&"
import script from "./confirmFreight.vue?vue&type=script&lang=js&"
export * from "./confirmFreight.vue?vue&type=script&lang=js&"
import style0 from "./confirmFreight.vue?vue&type=style&index=0&id=8287766e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./confirmFreight.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8287766e",
  null
  
)

export default component.exports